import axios from "axios";
import { notify } from "./notification";
import { baseUrl, encryptedBaseUrl } from "../config/urls";
import { currentStore } from "../../store/useStore";
import { GasPrice, calculateFee } from "@cosmjs/stargate";
import { SigningCosmWasmClient } from "@cosmjs/cosmwasm-stargate";
import { getAccessToken } from "./auth";
import History from "./GlobalNavigation/navigationHistory";



const chainId = "coreum-mainnet-1";

function unit8ArrayToHex(byteArray: Uint8Array): string {
  return Array.from(byteArray, (byte) =>
    byte.toString(16).padStart(2, "0")
  ).join("");
}



export const cosmos_sign_message = async (): Promise<{
  message: string;
  signed_message: string;
  address: string;
  alternativeAddress: string;
} | void> => {
  try {
    const store = currentStore();
    const cosmoskitClient = store?.currentProvider?.cosmoskitClient;
    const currentWallet = cosmoskitClient.constructor.name
    const response = await (cosmoskitClient as any).getAccount(chainId);
    const signerAddress = response?.address;
    const hexPublicAddress = unit8ArrayToHex(response?.pubkey);
    const res = await axios.get(
      `${baseUrl}/api/auth/get_message?publicKey=${hexPublicAddress}&encryption=true`
    );
    const message = res.data;

    const signDoc = {
      chain_id: currentWallet === 'CosmostationClient' ? chainId : '',
      account_number: "0",
      sequence: "0",
      fee: {
        amount: [],
        gas: "0",
      },
      msgs: [{
        type: "sign/MsgSignData",
        value: {
          signer: signerAddress,
          data: Buffer.from(message).toString('base64'),
        },
      }],
      memo: "",
    };

    const signatureResponse = await cosmoskitClient?.signAmino(
      chainId,
      signerAddress,
      signDoc
    );
    return {
      message: message,
      signed_message: signatureResponse?.signature.signature,
      address: hexPublicAddress,
      alternativeAddress: signerAddress
    };

  } catch (error) {

  }
};

export const coreum_sign_auth_message = async (): Promise<string | void> => {
  try {
    const store = currentStore();
    const cosmoskitClient = store?.currentProvider?.cosmoskitClient;
    const currentWallet = cosmoskitClient.constructor.name;

    try {
      const response = await (cosmoskitClient as any).getAccount(chainId);
      const signerAddress = response?.address;
      const hexPublicAddress = unit8ArrayToHex(response?.pubkey);
      const messageRequested = await axios.get(
        `${encryptedBaseUrl}/api/message/${hexPublicAddress}`
      );
      const message = messageRequested?.data?.[0]?.message;

      const signDoc = {
        chain_id: currentWallet === 'CosmostationClient' ? chainId : '',
        account_number: "0",
        sequence: "0",
        fee: {
          amount: [],
          gas: "0",
        },
        msgs: [{
          type: "sign/MsgSignData",
          value: {
            signer: signerAddress,
            data: Buffer.from(message).toString('base64'),
          },
        }],
        memo: "",
      };

      const signatureResponse = await cosmoskitClient?.signAmino(
        chainId,
        signerAddress,
        signDoc
      );
      return signatureResponse?.signature.signature
    } catch (error) {

    }
  } catch (error) {

  }
};

export const USDToCore = async (amount: number): Promise<string | any> => {
  const response = await axios.get(
    `${baseUrl}/api/lighthouse/get_ticker?symbol=coreum`
  );
  const conversionRate = response?.data;
  const amountInCore = (amount / conversionRate).toFixed(2);
  return amountInCore;
};

export const initiateCoreumPayment = async (
  amount: number,
  planID: string,
setIsLoading: (isLoading: boolean) => void
): Promise<void> => {
  const store = currentStore();
  const cosmoskitClient = store?.currentProvider?.cosmoskitClient;
  const offlineSigner: any = cosmoskitClient.getOfflineSigner(chainId);
  const rpcEndpoint = 'https://coreum-rpc.publicnode.com:443';
  const client = await SigningCosmWasmClient.connectWithSigner(
    rpcEndpoint,
    offlineSigner
  );
  const response = await axios.get(`${baseUrl}/api/lighthouse/get_ticker?symbol=coreum`);
  const conversionRate = response?.data;
  const amountInCore = (amount / conversionRate).toFixed(2);
  const accounts = await offlineSigner.getAccounts();
  const fixedAmount = (parseFloat(amountInCore) * 1000000).toString();
  const gasPrice = GasPrice.fromString("0.0625ucore");
  try {
    const sendResult = await client.sendTokens(
      accounts?.[0].address,
      'core145f5j80zfr730kndlx7ek55pt6ya0kcnr6d9ha',
      [{ denom: "ucore", amount: fixedAmount }],
      calculateFee(500000, gasPrice),
      "Lighthouse payment plan"
    );
    if (sendResult?.transactionHash) {
      const response = await axios.post(
        `${baseUrl}/api/topup/purchase_plan_via_coreum`,
        {
          subscriptionId: planID + '',
          transactionHash: sendResult?.transactionHash,
          address: accounts?.[0].address,
          amount: amountInCore,
        },
        {
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          maxContentLength: 100000000,
          maxBodyLength: 1000000000,
        }
      );
      response && notify(
        "Transaction Success: It can take a few minutes for the plan to get activated",
        "success"
      );
    }
    History.push('/dashboard');
  } catch (error) {
    setIsLoading(false);
    notify("Something Went Wrong! Please Try Again",
      "error"
    );
  }
};

export const getCoreumTokenBalance = async (): Promise<string | any> => {
  const store = currentStore();
  const cosmoskitClient = store?.currentProvider?.cosmoskitClient;
  const offlineSigner: any = cosmoskitClient.getOfflineSigner(chainId);
  const rpcEndpoint = 'https://coreum-rpc.publicnode.com:443';
  const client = await SigningCosmWasmClient.connectWithSigner(
    rpcEndpoint,
    offlineSigner
  );
  const accounts = await offlineSigner.getAccounts();
  const balance = await client.getBalance(accounts?.[0].address, "ucore");
  const returnValue = ((parseFloat(balance.amount) / 1000000).toFixed(2) || '0');
  return returnValue;
};
